import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pedestrian: 0,
  auto: 0,
  transit: 0,
  bicycle: 0,
  freight: 0
}

const weakestLinkScores = createSlice({
  name: 'weakestLinkScores',
  initialState,
  reducers: {
    setWeakestLinkScores(state, action) {
      const { field, value } = action.payload
      state[field] = value
    }
  }
})

export const { setWeakestLinkScores } = weakestLinkScores.actions
export default weakestLinkScores.reducer
